import { useContext, useEffect, useState } from "react";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/ManageAssignedCustomers.css";
import { AppContext } from "../../../AppProvider";
import { DashboardContext } from "./DashboardProvider";
const ManageAssignedCustomers = ({showManageAssignedCustomersWindow,setShowManageAssignedCustomersWindow}) =>{
    const {user,logout} = useContext(AppContext);
    const {selectedTenantAdminProfile,setDashboardSummaries,dashboardSummary,setDashboardSummary} = useContext(DashboardContext);
    const [customers,setCustomers] = useState([]);
    const [customerSearchTerm,setCustomerSearchTerm] = useState('');
    const [showCustomersBrowser,setShowCustomersBrowser] = useState(false);
    const [dashboardAssignedCustomers,setDashboardAssignedCustomers] = useState([]);
    const fetchCustomers = async() =>{
        if(!selectedTenantAdminProfile) return;
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/customers`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setCustomers(responseData);
            }
            else if(response.status === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.log('An error occurred when retrieving customers: ',error);
        }
    };
    const updateDashboardAssignedCustomers = async() =>{
        try{
            if(!dashboardSummary.id){
                window.alert('Invalid dashboard');
                return;
            }
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/dashboards/${dashboardSummary.id}/customers/assigned`;
            const response = await fetch(url,{
                method:'PATCH',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                },
                body:JSON.stringify({
                    customerIds: dashboardAssignedCustomers && dashboardAssignedCustomers.length > 0?
                    dashboardAssignedCustomers.map((dashboardAssignedCustomer) =>(dashboardAssignedCustomer?.local?.id)):[]
                })
            });
            if(response.ok){
                await updateDashboardSummary();
                setDashboardSummary(null);
                setShowCustomersBrowser(false);
                return;
            }
            else throw new Error('Response code: ', response.status);
        }
        catch(error){
            console.error('An error occurred when updating dashboard assigned customers: ',error);
            window.alert('An error occurred when updating assigned customers');
        }
    };
    const updateDashboardSummary = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/dashboards/${dashboardSummary?.id}/summary`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDashboardSummaries(prev => prev.map(summary => summary.id === responseData?.id? responseData:summary));
            }
            else throw new Error('Response code: ',response.status)
        }
        catch(error){
            console.error('An error occurred when updating a dashboard summary',error);
        }
    };
    const customersEqualAndValid = (customers1, customers2) => {
        if (!Array.isArray(customers1) || !Array.isArray(customers2)) return false;
        if (customers1.length !== customers2.length) return false;

        for (const cust1 of customers1) {
            const match = customers2.find(cust2 => cust2.id === cust1.id);
            if (!match) return false;
        }
        return true;
    };
    useEffect(() =>{
        fetchCustomers();
    },[showManageAssignedCustomersWindow]);
    useEffect(() =>{
        if(showManageAssignedCustomersWindow && dashboardSummary){
            setDashboardAssignedCustomers(dashboardSummary?.customers);
        }
    },[showManageAssignedCustomersWindow,dashboardSummary]);
    if(!showManageAssignedCustomersWindow || !dashboardSummary) return null;
    return(
        <div className="manage-assigned-customers-parent-container">
            <div className="manage-assigned-customers-container">
                <div className="header">
                    <h1>Manage assigned customers</h1>
                    <p onClick={() =>{
                        setDashboardSummary(null);
                        setShowManageAssignedCustomersWindow(false);
                    }}>&#10006;</p>
                </div>
                <div className="body">
                    <p>Assigned customers</p>
                    <div className="assigned-customers-entry-container">
                        {dashboardAssignedCustomers.map((dashboardAssignedCustomer) =>(
                            <div key={dashboardAssignedCustomer?.local?.id} className="assigned-customer-entry">
                            {dashboardAssignedCustomer?.external?.name}
                            <p onClick={() =>setDashboardAssignedCustomers(prev => prev.filter(c => c?.local?.id !== dashboardAssignedCustomer?.local?.id))}>&#10005;</p>
                            </div>
                        ))}
                        <input
                            placeholder="Select customers"
                            value={customerSearchTerm}
                            onChange={(e) => setCustomerSearchTerm(e.target.value)}
                            onFocus={() => setShowCustomersBrowser(true)}
                            onBlur={() =>{
                                setTimeout(() =>{
                                    setShowCustomersBrowser(false)
                                },200);
                            }}
                        />
                        <div className={`customers-browser-container ${showCustomersBrowser? 'active':''}`}>
                            {customers && customers.length > 0 &&
                            customers.filter(c => c?.external?.name?.toLowerCase().includes(customerSearchTerm.toLowerCase()) &&
                            !dashboardAssignedCustomers.some(assigned => assigned?.local?.id === c?.local?.id))
                            .sort((a,b) => a?.external?.name.localeCompare(b?.external?.name)).map(customer => (
                                <div key={customer.id?.id} onClick={() =>{
                                    setCustomerSearchTerm('');
                                    setDashboardAssignedCustomers(prev => [...prev,{
                                        local:{id:customer?.local?.id},
                                        external:{name:customer?.external?.name}
                                    }]);
                                }}>
                                    {customer?.external?.name}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="footer">
                    <button className="cancel-button" onClick={() =>{
                        setDashboardSummary(null);
                        setShowManageAssignedCustomersWindow(false);
                    }}>Cancel</button>
                    <button
                        className={`update-button ${customersEqualAndValid(dashboardAssignedCustomers,dashboardSummary?.customers)? 'inactive':'active'}`}
                        onClick={async() => await updateDashboardAssignedCustomers()}>Update</button>
                </div>
            </div>
        </div>
    );
};
export default ManageAssignedCustomers;